import { useEffect, useState } from 'react';
import { Drawer, Table, Tag, Space, Spin, Empty, message } from 'antd';
import { getBudgetVersionsApi } from 'api/hallazgoFlujo';
import { stageMeta, budgetOverlayBadges } from 'assets/data/estadosPresupuesto';

/**
 * Drawer con la cadena de versiones de un presupuesto (Fase 2). Consume
 * GET /budgets/:id/versions y lista cada revisión con su etapa + badges
 * vencido/histórico. Solo lectura.
 */
function BudgetVersionHistoryDrawer({ open, onClose, idBudget }) {
  const [loading, setLoading] = useState(false);
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    if (!open || !idBudget) return;
    let active = true;
    setLoading(true);
    getBudgetVersionsApi(idBudget)
      .then((res) => {
        if (!active) return;
        if (res?.codeMessage) {
          message.error(res.message || 'No se pudo cargar el historial');
          setVersions([]);
        } else {
          setVersions(Array.isArray(res?.versions) ? res.versions : []);
        }
      })
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [open, idBudget]);

  const columns = [
    {
      title: 'Versión',
      dataIndex: 'revision',
      key: 'revision',
      width: 90,
      render: (rev, row) => (
        <Space size={4}>
          <strong>v{rev}</strong>
          {!row.superseded && <Tag color="blue">Actual</Tag>}
        </Space>
      ),
    },
    {
      title: 'Etapa',
      dataIndex: 'stage',
      key: 'stage',
      render: (stage, row) => {
        const meta = stageMeta[stage];
        return (
          <Space size={4} wrap>
            <span>{meta?.description ?? stage}</span>
            {budgetOverlayBadges(row).map((b) => (
              <Tag key={b.key} color={b.color}>
                {b.text}
              </Tag>
            ))}
          </Space>
        );
      },
    },
    {
      title: 'Vence',
      dataIndex: 'valid_until',
      key: 'valid_until',
      width: 130,
      render: (v) => (v ? new Date(v).toLocaleDateString() : '—'),
    },
    {
      title: 'Creada',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 130,
      render: (v) => (v ? new Date(v).toLocaleDateString() : '—'),
    },
  ];

  return (
    <Drawer
      title="Historial de versiones"
      open={open}
      onClose={onClose}
      width={560}
      destroyOnHidden
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin />
        </div>
      ) : versions.length === 0 ? (
        <Empty description="Sin versiones" />
      ) : (
        <Table
          rowKey="id"
          size="small"
          columns={columns}
          dataSource={versions}
          pagination={false}
        />
      )}
    </Drawer>
  );
}

export default BudgetVersionHistoryDrawer;
